import React from "react";
import Header from "../components/Header";
import OnlineRegistration from '../components/OnlineRegistration'
import Highlights from '../components/Highlights'
import HomeGallery from "../components/HomeGallery";
import Footer from "../components/Footer";
import ModalPopup from '../components/ModalPopup';
import { NavLink } from "react-router-dom";
import Testimonials from "../components/Testimonials";
import BirthDay from "../components/BirthDay";
const Home = () => {
    return (
        <>
            <div class="erp-links">
                <a href="http://www.smnscampuscare.in/" target="_blank">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Campulogo.png" alt="smnsbokaro"
                        class="img-fluid" />
                </a>
            </div>
            <div class="social-links">
                <a href="https://www.instagram.com/smnsbokarojh?igsh=NHNlYTJ0cW9haXc0" target="_blank" title="Instagram"><i class="bi bi-instagram"></i></a>
                <a href="https://www.facebook.com/share/1Yr5YLRYZa/" target="_blank" title="Facebook"><i class="bi bi-facebook"></i></a>
                <a href="https://www.linkedin.com/" target="_blank" title="LinkedIn"><i class="bi bi-linkedin"></i></a>                
                <a href="https://youtu.be/JsBiff14dzc?si=G4xBfIfmMF-hutMc" target="_blank" title="YouTube"><i class="bi bi-youtube"></i></a>
            </div>
            <Highlights />
            <ModalPopup />
            <Header />
            <section id="slider">
                <div id="singleImageCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Slider.jpg" class="d-block w-100" alt="smnsbokaro" />
                        </div>
                        <div class="carousel-item">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/slide1.jpg" class="d-block w-100" alt="smnsbokaro" />
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#singleImageCarousel" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#singleImageCarousel" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </section>
            <OnlineRegistration />
            <div className="sldvector">
                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Vector-1.png" class="d-block w-100" alt="smnsbokaro" />
            </div>
            {/* About Us */}
            <section className="AboutUs">
                <div className="container">
                    <div id="schoolCarousel" className="carousel slide" data-bs-ride="carousel">
                        {/* Optional: Indicators */}
                        {/* <div className="carousel-indicators">
                            <button type="button" data-bs-target="#schoolCarousel" data-bs-slide-to="0" className="active" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#schoolCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        </div> */}
                        {/* Carousel Slides */}
                        <div className="carousel-inner">
                            {/* Slide 1 */}
                            <div className="carousel-item active">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 col-md-7">
                                        <div className="about-des">
                                            <h3 className="h3">
                                                Welcome to <br />St. Mary’s Nursery School, Bokaro
                                            </h3>
                                            <p><b>Where Little Steps Lead to Lifelong Learning!</b></p>
                                            <p>
                                                At <b>St. Mary’s Nursery School (SMNS), Bokaro,</b> we believe that every child’s first experience of school should be filled with joy, curiosity, and care. An <b>English Medium Co-educational Institution,</b> SMNS functions under the aegis of <b>St. Thomas Orthodox Church Mission, Bhilai, Chhattisgarh,</b> and is guided by the values of the
                                                <b>Indian Orthodox Church.</b>
                                            </p>
                                            <br />
                                            <NavLink to="/About">
                                                <div className="buttonbg">
                                                    Read More <i className="bi bi-arrow-right"></i>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-5">
                                        <div className="school_blk position-relative">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/about.png" className="school-view img-fluid mx-auto d-block" alt="St Mary Bokaro" />
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/bird.gif" className="bird position-absolute" alt="Bird" style={{ top: '10px', right: '10px', width: '50px' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Slide 2 */}
                            <div className="carousel-item">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 col-md-5">
                                        <div className="school_blk video">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/video.png" className="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-7">
                                        <div className="mission-des">
                                            <h3>Mission</h3>
                                            <p>To prepare students to understand, contribute to, and succeed in a rapidly changing society, thus
                                                making the world a better and more just place.</p>

                                            <h3>Vision</h3>
                                            <p>To empower the students to lead a life in fullness, by fostering creativity, enhancing power of Critical
                                                Thinking, developing Social Skills, inculcating Moral Values in them.</p>
                                            <br />
                                            <NavLink to="/MissionVision">
                                                <div className="buttonbg">
                                                    Read More <i className="bi bi-arrow-right"></i>
                                                </div>
                                            </NavLink>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Admission Open */}
            <section className="admissionsec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="admissionarea">
                                <div className="admission-img">
                                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/admissionbg.png" alt="smnsbokaro" />
                                </div>
                                <div className="admission-text">
                                    <h3 className="h3">Admission Open</h3>
                                    <p>
                                        The admission is generally conducted for Pre - Nursery class. Every child who is admitted in Pre- Nursery has to undergo three years of study i.e. Pre - Nursery, Nursery and Prep. There is no written test for admission to Pre - Nursery class. The general intelligence of the child is taken into consideration. The general intelligence does not test a child’s knowledge in any particular subject, instead it is designed to assess the suitability of the child to cope up with the academic and general atmosphere of the school. Admission to Nursery and Prep classes are conducted subject to vacancies, if any. All students after successfully completing their studies of PREP from this school are eligible for direct admission to Class 1 at M.G.M. Higher Secondary School, Sector 4/F, Bokaro,
                                    </p>
                                    <NavLink to="/AdmissionDetails">
                                        <div className="buttonbg">
                                            Read More <i className="bi bi-arrow-right"></i>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rainbow">
                        <img src="https://webapi.entab.info/api/image/SMNSB/public/images/rainbow.png" alt="Right Decoration" />
                    </div>
                </div>
            </section>
            {/* MESSAGE SECTION */}
            <div class="message_section padded-sec">
                <div class="container-fluid">
                    <div className="row py-3">
                        <div className="col-12">
                            <h3 className="text-center h3">FROM THE DESK OF</h3>
                            <p className="text-center">MESSAGE SECTION</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="message_blk">
                                <div class="d-flex">
                                    <div class="message_content orderd-2">
                                        <h5>Chairman’s Message </h5>
                                        <p>
                                            A warm welcome to you all! I hope you all had a refreshing and fruitful vacation. Every new school year is a fresh beginning full of promises and possibilities. It is a chance to leave behind what didn't work and embrace the new opportunities that lie ahead. Whether you are stepping onto the campus for the first time or returning after your vacation, be proud that you are part of a vibrant MGM community, a brand in itself.
                                            <br />
                                            School days are the happiest days of our lives. School is like a second home for every student, where your teachers and friends are your family. Respect your parents, teachers, and elders, and foster good and meaningful relationships with your schoolmates. Friendships developed at school not only fulfill the purpose of having fun but also promote a strong sense of positivity and mental well-being, encouraging learning and interpersonal skills. At school, we cultivate strong values, which are a powerful instrument for social change and human progress. Prioritize values like love, honesty, loyalty, mutual respect, and empathy in your lives.
                                        </p>
                                        <button class="button"><a href="/ChairmanMessage"> View All </a></button>
                                    </div>
                                    <div class="message_img chairman orderd-1">
                                        <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/chairman.jpg" /></div>
                                        {/* <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/message-btn.gif" class="message-btn" /></div> */}
                                    </div>
                                    <div class="message_content orderd-6">
                                        <h5>Founder’s Message</h5>
                                        <p>
                                            His Grace Dr. Stephanos Mar Theodosius of Blessed Memory<br />
                                            Former Metropolitan of the Diocese of Kolkata<br />
                                            God chooses great leaders to lead his people and to be good stewards in His kingdom. His Grace Dr. Stephanos Mar Theodosius, the former Bishop of Kolkata Diocese of the Indian Orthodox Church, was one such visionary leader. He was born on 2 October1924 in Pathamoothom, Kottayam, Kerala and was named Punnose by his parents.
                                        </p>
                                        <button class="button"><a href="/FounderMessage"> View All </a></button>
                                    </div>
                                    <div class="message_img founder orderd-3">
                                        <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/founder.jpg" /></div>
                                        {/* <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/message-btn.gif" class="message-btn" /></div> */}
                                    </div>
                                    <div class="message_content orderd-4">
                                        <h5>St. Mary’s</h5>
                                        <p>St. Mary, the Blessed Mother of our Lord, is the guiding light and Patron Saint of St. Mary’s Nursery School, Bokaro.
                                            Her life of humility, compassion, and unwavering faith inspires our vision of nurturing young hearts with love and moral strength.
                                            Under her gentle care, we uphold our school motto — “Love One Another” — fostering in every child the spirit of kindness, respect, and unity.
                                            <br />
                                            <i> “My soul magnifies the Lord, and my spirit rejoices in God my Saviour.”
                                                — Luke 1:46–47</i>
                                        </p>
                                        <button class="button"><a href="/StMaryMessage"> View All </a></button>
                                    </div>
                                    <div class="message_img patron orderd-5">
                                        <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/StMary.jpg" /></div>
                                        {/* <div class="lazyload-wrapper "><img src="https://webapi.entab.info/api/image/SMNSB/public/images/message-btn.gif" class="message-btn" /></div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* 4 Facilities */}
            < section className="four_blk" >
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-2 col-lg-3">
                            <div className="tm-floating-objects">
                                <span
                                    className="floating-object-2 tm-animation-floating z-index--1"
                                    style={{
                                        backgroundImage: "url('https://webapi.entab.info/api/image/SMNSB/public/images/boy.png')",
                                        height: '284px',
                                        width: '361px',
                                        bottom: '16%',
                                        left: '-5%',
                                        position: 'absolute',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        zIndex: 0,
                                    }}>
                                </span>
                            </div>
                        </div>
                        <div className="col-xl-10 col-lg-9">
                            <div className="row p-5 g-3">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="four_blk_inner-bor">
                                        <div className="four_blk_inner first">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/student.png" alt="smnsbokaro" className="img-fluid" />
                                            <h3>Moral Educatiaon</h3>
                                            <p>To inclucate moral values in the children, the school starts each working day with morning.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="four_blk_inner-bor">
                                        <div className="four_blk_inner second">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/teacher.png" alt="smnsbokaro" className="img-fluid" />
                                            <h3>Professional Teachers</h3>
                                            <p>Most of our Teachers are professionally qualified and possesses necessary techniques, strategy and approaches needed to nurture the children to develop their own views and independent opinion. The teachers are experts in soft skills, counseling skills, interpersonal skills, computer skills, and management skills and above all life long learning skills.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="four_blk_inner-bor">
                                        <div className="four_blk_inner third">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/parent.png" alt="smnsbokaro" className="img-fluid" />
                                            <h3>Parent Day</h3>
                                            <p>We firmly believe in inducing the young minds with the goodness, Moral Values, and Good Character. Our aim is to develop on overall personality of the students, so that they become independent, confident and responsible citizens of tomorrow with a dynamic view of life. All this can be achieved with encouragement from the parents.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="four_blk_inner-bor">
                                        <div className="four_blk_inner forth">
                                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/digital.png" alt="smnsbokaro" className="img-fluid" />
                                            <h3>Digital Educatiaon</h3>
                                            <p>The advances of ICT to provide quality education to every student of every class from primary, secondary and higher secondary groups in an extremely affordable cost.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div >
            </section >
            {/* Why choose Us */}
            < section className="WhychooseUs" >
                <div className="container">
                    <div className="row py-3">
                        <div className="col-12">
                            <h3 className="text-center h3">Why choose Us</h3>
                            <p className="text-center">Choosing the right preschool is a decision which every parent has to make to <br />ensure early childhood development of their kid.</p>
                        </div>
                    </div>
                    <br />
                    <div className="row g-5">
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-1.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>All Round Development</h4>
                                <p>At SMNS, we nurture every child’s physical, emotional, social, and intellectual growth through balanced activities that build confidence, curiosity, and compassion.</p>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-2.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>Well Trained Teachers</h4>
                                <p>Our dedicated and qualified teachers create a joyful learning atmosphere, ensuring personalized attention with a 1:15 teacher-student ratio.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-3.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>Structured Curriculum</h4>
                                <p>We follow an NEP-based, age-appropriate curriculum designed to promote experiential learning, critical thinking, and creativity in every child.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-4.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>Kids Marathon</h4>
                                <p>Encouraging fitness and fun, the SMNS Kids Marathon helps children develop sportsmanship, teamwork, and a spirit of healthy competition.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-5.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>Play Based Learning</h4>
                                <p>Through play-way methodology, we make learning enjoyable and meaningful—turning every moment into an opportunity to explore and discover.
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className="WhychooseUs-Box">
                                <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Why-6.png" class="img-fluid mx-auto d-block" alt="smnsbokaro" />
                                <h4>Safety & Security</h4>
                                <p>Your child’s safety is our top priority, ensured by 24×7 CCTV surveillance, RO purified drinking water, and a caring, well-supervised environment.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            {/* Our Curriculum */}
            < section className="OurCurriculum" >
                <div className="c-1">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/c-1.png" alt="Left Decoration" />
                </div>
                <div className="c-2">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/c-2.png" alt="Left Decoration" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <h3 className="h3 text-center">Our Curriculum</h3>
                            <p>
                                St. Mary’s Nursery School, Bokaro, offers a comprehensive and nurturing early childhood education program designed for Pre-Nursery, Nursery, and Prep levels. The school follows a structured, play-way and theme-based approach that encourages holistic development—cognitive, emotional, social, and physical. Children are engaged through a wide range of interactive and age-appropriate activities such as phonics, storytelling, art, music, dramatics, yoga, and physical exercises. The curriculum emphasizes language development, foundational literacy and numeracy, and the cultivation of moral values and social skills. Regular events like special assemblies, competitions, and annual sports day foster creativity, confidence, and teamwork. With dedicated staff, a child-friendly environment, and active parent involvement, SMNS ensures a joyful and strong foundation for lifelong learning.
                            </p>
                            <NavLink to="#">
                                <div className="buttonbg">
                                    Read More <i className="bi bi-arrow-right"></i>
                                </div>
                            </NavLink>
                        </div>
                        <div className="col-lg-4 col-md-5 Curriculum">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/Curriculum.png" alt="smnsbokaro" className="img-fluid mx-auto d-block" />
                        </div>
                    </div>
                </div>
                <div className="c-3">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/c-3.png" alt="smnsbokaro" />
                </div>
            </section >
            {/* Testimonials */}
            < section className="Testimonials" >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="col-12">
                                <h3 className="h3 text-center">
                                    <i className="bi bi-quote"></i> Testimonials <i className="bi bi-quote"></i>
                                </h3>
                            </div>
                        </div>
                    </div>
                    <br />
                    <Testimonials />
                </div>
            </section >
            {/* Gallery */}
            < div className="gallery" >
                <div className="g-1">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/g-1.png" alt="Left Decoration" />
                </div>
                <div className="container">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <div className="gallery-title">
                                <h3 className="h3 text-center">Where Every Smile Tells a Story & Student Birthday</h3>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <HomeGallery />
                            <br />
                            <center>
                                <NavLink to="/Gallery">
                                    <div className="buttonbg">
                                        View Images <i className="bi bi-arrow-right"></i>
                                    </div>
                                </NavLink>
                            </center>
                        </div>
                        <BirthDay />
                    </div>
                </div>
                <div className="g-2">
                    <img src="https://webapi.entab.info/api/image/SMNSB/public/images/g-2.png" alt="Right Decoration" />
                </div>
            </div >
            <Footer />
        </>
    );
};

export default Home;
